import React from "react";
import { Box, Container, Grid, Typography, Link } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import theme from "../../theme/theme.js";
import { useNavigate, Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main, // Bleu foncé comme dans l'image
        color: "white",
        py: { xs: 4, md: 6 },
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container justifyContent="space-between" spacing={{ xs: 3, md: 6, lg: 12 }}>
          {/* Contact Section */}
          <Grid
            sx={{
              width: { xs: "100%", md: "33.33%", lg: "33.33%" },
            }}
          >
            <Box
              component="section"
              tabIndex={-1}
              aria-labelledby="contact-heading"
              sx={{
                // "&:focus": {
                //   outline: "2px solid white",
                //   outlineOffset: "2px",
                // },
                "&:focus-visible": {
                  outline: "2px solid white",
                  outlineOffset: "2px",
                },
              }}
            >
              <Typography
                id="contact-heading"
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  fontSize: { xs: "1.1rem", md: "1.25rem" },
                  color: "white",
                }}
              >
                {t("footer.contact")}
              </Typography>

              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    color: "white",
                    fontWeight: 500,
                    fontSize: { xs: "0.9rem", md: "1rem" },
                  }}
                >
                  {t("footer.address")}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                  <Link
                    href="mailto:eta@piba.gov.il"
                    color="inherit"
                    underline="none"
                    aria-label={t("footer.email")}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "0.9rem", md: "1rem" },
                      "&:hover": {
                        color: "#FF6B35",
                        "& .arrow-icon": {
                          transform: "translateX(4px)",
                        },
                      },
                      "&:focus": {
                        outline: "2px solid white",
                        outlineOffset: "2px",
                        color: "#FF6B35",
                      },
                      "&:focus-visible": {
                        outline: "2px solid white",
                        outlineOffset: "2px",
                      },
                      transition: "color 0.2s ease",
                    }}
                  >
                    {t("footer.email")}

                  </Link>
                  <span style={{ color: "white", fontWeight: 600 }}>({t("footer.emailNote")})</span>
                  <Link
                    href="tel:+972-2-535-9740"
                    color="inherit"
                    underline="none"
                    aria-label={t("footer.phone")}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "0.9rem", md: "1rem" },
                      "&:hover": {
                        color: "#FF6B35",
                        "& .arrow-icon": {
                          transform: "translateX(4px)",
                        },
                      },
                      "&:focus": {
                        outline: "2px solid white",
                        outlineOffset: "2px",
                        color: "#FF6B35",
                      },
                      "&:focus-visible": {
                        outline: "2px solid white",
                        outlineOffset: "2px",
                      },
                      transition: "color 0.2s ease",
                    }}
                  >
                    {t("footer.phone")}

                  </Link>
                </Box>
              </Box>

              {/* Logos des réseaux sociaux */}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/israel.svg`}
                  alt=""
                  sx={{
                    width: { xs: "10%", md: "15%" },
                    height: "auto",
                    objectFit: "contain",
                    // filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))",
                  }}
                />
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/logo.png`}
                  alt="Logo Israel Population & Immigration Authority"
                  sx={{
                    width: { xs: "10%", md: "15%" },
                    objectFit: "contain",
                    height: "auto",
                    // filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))",
                  }}
                />
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/misradahouts.png`}
                  alt="Logo Israel Population & Immigration Authority"
                  sx={{
                    width: { xs: "10%", md: "15%" },
                    objectFit: "contain",
                    height: "auto",
                    // filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.3))",
                  }}
                />
              </Box>
            </Box>
          </Grid>

          {/* Get Help Section */}
          <Grid>
            <Box
              component="section"
              tabIndex={-1}
              aria-labelledby="get-help-heading"
              sx={{
                // "&:focus": {
                //   outline: "2px solid white",
                //   outlineOffset: "2px",
                // },
                "&:focus-visible": {
                  outline: "2px solid white",
                  outlineOffset: "2px",
                },
              }}
            >
              <Typography
                id="get-help-heading"
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  fontSize: { xs: "1.1rem", md: "1.25rem" },
                  color: "white",
                }}
              >
                {t("footer.getHelp")}
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Link
                  component={RouterLink}
                  to="/visa-option"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.exploreVisaOptions")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.exploreVisaOptions")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                <Link
                  href={process.env.REACT_APP_SITE + `EligibilityNational?lang=${i18n.language}`}
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.checkEligibility")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.checkEligibility")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                <Link
                  component={RouterLink}
                  to="/get-help"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.getHelpLink")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.getHelpLink")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                <Link
                  component={RouterLink}
                  to="/learn-about"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.discoverEtail")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.discoverEtail")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>
                <Link
                  component={RouterLink}
                  to="/learn-about-evisa-b2"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.discoverEvisaB2")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.discoverEvisaB2")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>
                {/* <Link
                  component={RouterLink}
                  to="/resend-confirmation"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.resendConfirmation")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.resendConfirmation")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link> */}
              </Box>
            </Box>
          </Grid>

          {/* Terms Section */}
          <Grid>
            <Box
              component="section"
              tabIndex={-1}
              aria-labelledby="terms-heading"
              sx={{
                // "&:focus": {
                //   outline: "2px solid white",
                //   outlineOffset: "2px",
                // },
                "&:focus-visible": {
                  outline: "2px solid white",
                  outlineOffset: "2px",
                },
              }}
            >
              <Typography
                id="terms-heading"
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  fontSize: { xs: "1.1rem", md: "1.25rem" },
                  color: "white",
                }}
              >
                {t("footer.sitePolicies")}
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Link
                  href="https://www.gov.il/he/pages/accessibility_declaration"
                  color="inherit"
                  underline="none"
                  aria-label={t("footer.accessibility")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.accessibility")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                {/* <Link
                  onClick={() => {navigate("/terms")}}
                  color="inherit"
                  underline="none"
                  tabIndex={0}
                  aria-label={t("footer.termsLink")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.termsLink")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                <Link
                  onClick={() => {navigate("/conditions")}}
                  color="inherit"
                  underline="none"
                  tabIndex={0}
                  aria-label={t("footer.conditions")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.conditions")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link>

                <Link
                  onClick={() => {navigate("/security")}}
                  color="inherit"
                  underline="none"
                  tabIndex={0}
                  aria-label={t("footer.security")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    "&:hover": {
                      color: "#FF6B35",
                      "& .arrow-icon": {
                        transform: "translateX(4px)",
                      },
                    },
                    "&:focus": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                      color: "#FF6B35",
                    },
                    "&:focus-visible": {
                      outline: "2px solid white",
                      outlineOffset: "2px",
                    },
                    transition: "color 0.2s ease",
                  }}
                >
                  {t("footer.security")}
                  <ArrowForward
                    className="arrow-icon"
                    sx={{
                      ml: 1,
                      fontSize: "1rem",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Link> */}
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            pt: 3,
            mt: 4,
            textAlign: "left",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              opacity: 0.8,
              fontSize: { xs: "0.85rem", md: "0.9rem" },
              color: "white",
            }}
          >
            {t("footer.copyright")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
